import React from 'react';
import moment from 'moment';
import {useGlobalState} from '../../../state';
import { Grid, Chip } from '@material-ui/core';
import { MaterialTable } from '../../../components';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Mobile from './mobile';
import { minChipLabel } from '../../../views/FeedFormulation/utils/constants';
import EnergyTooltip from '../components/materialTypeComponents/EnergyTooltip';
const PurchaseMaterialTable = ({
    purchaseMaterials,
    actions,
    onSaleEdit,
    onDelete
})=>{
    const [{user}] = useGlobalState();

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });

    const amountObj = {
        style: "currency",
        currency: user.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }

    function formatPurchaseMaterials(){
        let tArray = [];
        for(var i in purchaseMaterials){
            var item = purchaseMaterials[i];
            // Calculate total bill value from all materials
            const totalBillValue = item.purchaseMaterials.reduce((sum, material) => {
                let materialBillValue = 0;
                if (material.weightType === 1 && material.commissionPerUnit > 0) {
                    materialBillValue = (material.billWeight * (material.costPerUnit + material.commissionPerUnit));
                } else if (material.weightType === 2 && material.commissionPerUnit > 0) {
                    materialBillValue = (material.deliveryWeight * (material.costPerUnit + material.commissionPerUnit));
                } else {
                    materialBillValue = (material.deliveryWeight * material.costPerUnit);
                }
                return sum + materialBillValue;
            }, 0);
            var nObj = {
                ...item,
                farmName: item.purchaseMaterials[0].farmName.String,
                billValue: totalBillValue,
            };
            nObj['mID'] =  nObj.id; // temp `id`
            tArray.push(nObj);
        }
        return tArray;
    }
    
    return(
        <MaterialTable 
        columns={[
            { title: 'id', field: 'id', hidden: true },
            {
                title: 'Purchase Details',
                field: 'purchaseDetails',
                hidden: isDesktop, // This column will only show on mobile
                render: rowData => (
                    <Mobile 
                        data={rowData}
                        onEdit={() => onSaleEdit(rowData)}
                        onDelete={() => onDelete(rowData)}
                        amountObj={amountObj}
                    />
                ),
                customFilterAndSearch: (term, rowData) => {
                    return rowData?.purchaseMaterials?.some(material =>
                        material?.materialName.toLowerCase().includes(term.toLowerCase()) || material?.farmName.String.toLowerCase().includes(term.toLowerCase())
                    );
                },
            },
            {
                title: 'No', field: 'id', editable: 'never', hidden: !isDesktop,
                render: (rowData) => {
                    return <span>{rowData.id}</span>
                }
            },
            {
                title: 'Date', field: 'date', type: 'datetime', defaultSort: 'desc', hidden: !isDesktop,
                cellStyle: {textAlign: 'center'}, headerStyle: {textAlign: 'center'},
                editable: 'never',
                render: rowData => {
                    return <span>{moment(rowData.date).format("DD-MM-YYYY")}</span>
                }
            },
            {
                title: 'Farm Name', field: 'farmName', editable: 'never', hidden: !isDesktop,
                render: (rowData) => { return <span>{rowData.farmName}</span> }
            },
            {
                title: 'Material Name',
                field: 'materialName',
                editable: 'never',
                hidden: !isDesktop,
                customFilterAndSearch: (term, rowData) => {
                    return rowData?.purchaseMaterials?.some(material =>
                        material?.materialName.toLowerCase().includes(term.toLowerCase())
                    );
                },
                render: (rowData) => (
                    <Grid container spacing={1} wrap='nowrap'>
                        {rowData?.purchaseMaterials?.map((material, index) => {
                            if(index < minChipLabel){
                                return (

                                    <Grid item key={index}>
                                        <Chip
                                            label={material.materialName}
                                            color="primary"
                                            size='small'
                                        />
                                    </Grid>
                                )
                            }
                            return null;
                        })}
                        {
                            rowData?.purchaseMaterials?.length > minChipLabel ?
                           <EnergyTooltip 
                            arrow={true}
                            title = {
                                <Grid container spacing={1}>
                                    {rowData?.purchaseMaterials?.map((material, index) => {
                                        if (index >= minChipLabel){

                                            return (
    
                                                <Grid item key={index}>
                                                    <Chip
                                                        label={material.materialName}
                                                        color="primary"
                                                        size='small'
                                                    />
                                                </Grid>
                                            )
                                        }
                                        return null;
                                        
                                    })}
                                </Grid>
                            }
                             >
                            <Grid item>
                                <Chip size="small" color="primary" label={`+ ${rowData?.purchaseMaterials.length - minChipLabel}`} />
                            </Grid>
                        </EnergyTooltip> :""
                        }

                    </Grid>
                )
            },
            {
                title: 'Total amount', field: 'billValue', editable: 'never', hidden: !isDesktop,
                render: (rowData) => {
                    return <span>{rowData.billValue.toLocaleString(user.locales,amountObj)}</span>
                },
            },
            // {
            //     title: 'Remaining Balance', field: 'remainingBalance', editable: 'never',
            //     cellStyle: {textAlign:'center'}, headerStyle: {textAlign:'center'},
            //     render: rowData => {
            //         let totalAmount = 0
            //         let gstAmount = 0
            //         let tdsAmount = 0
            //         let tcsAmount = 0
            //         let billValue = 0
            //         let totalAmountPaid = 0

            //         if(!isPro){
            //             if (rowData && rowData.purchaseMaterials) {
            //                 let purchaseMaterials = rowData.purchaseMaterials
            //                 purchaseMaterials.forEach(purchaseMaterial => {
            //                     let gstTaxAmt = parseFloat((purchaseMaterial.billValue * (purchaseMaterial.gst ? purchaseMaterial.gst : 0) / 100).toFixed(2))
            //                     let tdsTaxAmt = parseFloat((purchaseMaterial.billValue * (rowData.tds ? rowData.tds : 0) / 100).toFixed(2))
            //                     let tcsTaxAmt = parseFloat((purchaseMaterial.billValue * (rowData.tcs ? rowData.tcs : 0) / 100).toFixed(2))
            //                     gstAmount += gstTaxAmt
            //                     tdsAmount += tdsTaxAmt
            //                     tcsAmount += tcsTaxAmt
            //                     billValue += purchaseMaterial.billValue
            //                 })
            //             }
                       
            //             let gstTCSVal = gstAmount * (rowData.tcs/100)
            //             let totalTCS = Math.ceil(tcsAmount + gstTCSVal)
            //             totalAmount = billValue + totalTCS + gstAmount - tdsAmount
            //         }
            //         else{
            //             totalAmount = rowData.billValue;
            //         }
                    
            //         if (rowData && rowData.purchasePayments && rowData.purchasePayments.length) {
            //             let purchasePayments = rowData.purchasePayments
            //             purchasePayments.forEach(ele => {
            //                 totalAmountPaid += ele.paymentAmount
            //             })
            //         }

            //         let reminingAmount = totalAmount - totalAmountPaid;
            //         if (rowData.paymentStatus === 2 && reminingAmount < 1) {
            //             reminingAmount = 0
            //         }

            //         return <span>{reminingAmount.toLocaleString(user.locales,amountObj)}</span>

            //     }
            // },
            // {
            //     title: 'Payment Status', field: 'paymentStatus', editable: 'never',
            //     cellStyle: {textAlign:'center'}, headerStyle: {textAlign:'center'},
            //     render: (rowData) => {
            //         let statusIcon = [
            //         <Tooltip title="Not Paid"><CloseIcon className={classes.red} /></Tooltip>,
            //         <Tooltip title="Tax Not Paid"><CancelIcon style={{fontSize:"12"}}  className={classes.red} /></Tooltip>
            //         ]
                    
                    
            //         // let tdsValue = rowData.totalBillValue * (rowData.tds / 100)
            //         let remaningBalance;
            //         if(!isPro){
            //             remaningBalance = (rowData.totalBillValue - ((rowData.totalBillValue * (rowData.tcs / 100))) - (rowData.totalBillValue * (rowData.tds/100)) - rowData.totalAmountPaid).toFixed(2);
            //         }
            //         else{
            //             remaningBalance = rowData.totalBillValue - rowData.totalAmountPaid;
            //         }

            //         let remaningBalanceWithoutTaxes = ((rowData.totalBillValue * (rowData.tcs / 100)) + (rowData.totalBillValue * (rowData.tds/100))) - rowData.totalTaxAmountPaid;


            //         if (rowData.paymentStatus === 1 && remaningBalance >= 1) {
            //             statusIcon.shift()
            //             statusIcon.unshift(<Tooltip title="Partially Paid"><QueryBuilderIcon /></Tooltip>)
            //         } else if (rowData.paymentStatus === 2 || (rowData.paymentStatus === 1 && remaningBalance < 1)) {
            //             statusIcon.shift()
            //             statusIcon.unshift(<Tooltip title="Paid"><DoneIcon className={classes.green} /></Tooltip>)
            //         }

            //         if(!isPro){
            //             if (rowData.totalTaxAmountPaid > 0 && remaningBalanceWithoutTaxes >= 1) { // Partially paid
            //                 statusIcon.pop()
            //                 statusIcon.push(<Tooltip title="Tax Partially Paid"><QueryBuilderIcon style={{fontSize:"12"}}  /></Tooltip>)
            //             } else if (rowData.totalTaxAmountPaid > 0 && remaningBalanceWithoutTaxes < 1) { // Fully paid
            //                 statusIcon.pop()
            //                 statusIcon.push(<Tooltip title="Tax Paid"><CheckCircleIcon style={{fontSize:"12"}}  className={classes.green} /></Tooltip>)
            //             }
            //         }

            //         if ((rowData.tcs === 0 && rowData.tds === 0)) {
            //             statusIcon.pop()
            //         }

            //         return <div style={{
            //             display:"flex",
            //             justifyContent:"center",
            //             alignItems:"center"
            //         }} >{statusIcon}</div>
            //     }
            // }
        ]}
        data={formatPurchaseMaterials()}
        options={{
            actionsColumnIndex: -1,
            search: true,
            showTitle: true,
            
            toolbar: true,
        }}
        //style={{boxShadow: 'unset'}}
        title='Purchase Table'
        actions={isDesktop ? actions : []}
    />
    );
};

export default PurchaseMaterialTable;